import { render, staticRenderFns } from "./ListActsTotal.vue?vue&type=template&id=5b38f468&"
import script from "./ListActsTotal.vue?vue&type=script&lang=ts&"
export * from "./ListActsTotal.vue?vue&type=script&lang=ts&"
import style0 from "./ListActsTotal.vue?vue&type=style&index=0&id=5b38f468&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports